import { DeepPartial, SearchBoxConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SEARCH_BOX_CONFIG: DeepPartial<SearchBoxConfig> = {
  components: {
    clearButtonContent: 'TuandcoSearchBoxClear',
    icon: null
  },
  autofocus: true
};

export const DESKTOP_SEARCH_BOX_CONFIG: DeepPartial<SearchBoxConfig> = {
  components: {
    icon: 'TuandcoSearchIcon',
    clearButtonContent: 'TuandcoSearchBoxClear',
  }
};
